<template>
  <div class="ui basic placeholder segment">
    <h1 class="ui icon header">
      <i class="eye slash icon"></i>
      You have no authentication methods associated with this Billing Id.
    </h1>
  </div>
</template>

<script>
export default {
  name: 'NoAuthentication',
};
</script>
